// import React from 'react';
// import ReactDOM from 'react-dom';
// import './index.css';
// import App from './App';
// import * as serviceWorker from './serviceWorker';

// ReactDOM.render(<App />, document.getElementById('root'));

// // If you want your app to work offline and load faster, you can change
// // unregister() to register() below. Note this comes with some pitfalls.
// // Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();

// must stay the first import: guards storage before other modules touch it
import './components/utils/safeStorage';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import config from './config/domain';
import { initMixpanelService } from './components/Services/mixpanelService';
import ErrorBoundary from './components/UI/ErrorBoundary/ErrorBoundary';

function logGlobalError(kind: string, error: any) {
  console.error(kind, error);
  try {
    (window as any).mixpanel?.track?.('error_triggered', {
      error_type: kind,
      error_message: String(error?.message || error),
      page_path: window.location.pathname,
      user_agent: navigator.userAgent,
    });
  } catch (e) {}
}

window.addEventListener('error', (event) => logGlobalError('window_error', event.error || event.message));
window.addEventListener('unhandledrejection', (event) => logGlobalError('unhandled_rejection', event.reason));

const container = document.getElementById('root');

if (!container) {
  throw new Error("Root container missing in index.html");
}

initMixpanelService(config.mixpanelToken);

const root = createRoot(container);
root.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);
